/**
 * New York ZIP codes: 10001–14975, plus 06390 (Fishers Island) and
 * 00501 / 00544 (Holtsville IRS). Optional ZIP+4 suffix.
 */
const NY_POSTCODE_REGEX = /^(1[0-4]\d{3}|06390|00501|00544)(-\d{4})?$/;

const US_STATE_POSTCODE_REGEXES = {
  NY: NY_POSTCODE_REGEX,
};

/**
 * Derives a US state code from a postcode. Returns null when the postcode
 * does not match a known state.
 */
const getUsStateCodeFromPostcode = (postcode) => {
  if (typeof postcode !== 'string') return null;

  const trimmedPostcode = postcode.trim();
  const matchedState = Object.entries(US_STATE_POSTCODE_REGEXES).find(
    ([, regex]) => regex.test(trimmedPostcode)
  );

  return matchedState ? matchedState[0] : null;
};

export default getUsStateCodeFromPostcode;
